import ApiClient from "@/api/v2/base";
import route from "@/bundles/route";

class PayoutsApi extends ApiClient {
    getPayoutMethods() {
        const url = route('api.v2.payouts.methods.list');
        return this.getAuthenticated(url);
    }

    deletePayoutMethod(id) {
        const url = route("api.v2.payouts.methods.delete", { id: id });
        return this.deleteAuthenticated(url);
    }

    createPayoutMethod(provider, data)
    {
        const url = route("api.v2.payouts.methods.create", { provider: provider });
        return this.postAuthenticated(url, data);
    }

    getRecentPayouts()
    {
        const url = route("api.v2.payouts.list");
        return this.getAuthenticated(url);
    }

    createPayout(data)
    {
        const url = route("api.v2.payouts.create");
        return this.postAuthenticated(url, data);
    }

    cancelPayout(id)
    {
        const url = route("api.v2.payouts.cancel", { id: id });
        return this.deleteAuthenticated(url);
    }

    processPayout(id)
    {
        const url = route("api.v2.payouts.process", { id: id });
        return this.postAuthenticated(url);
    }

    completePayout(id)
    {
        const url = route("api.v2.payouts.complete", { id: id });
        return this.postAuthenticated(url);
    }
}

export default PayoutsApi;
